import type { TaskAssigneeUser } from "@components/modules/resource-planning/tasks/components/task-assignees/types";
import type { AvatarStackItem } from "@components/ui-kit/avatar/variants/stack/types";

/** Internal users get the profile popover, so no plain tooltip for them. */
export function hasProfileTooltip(user: TaskAssigneeUser): boolean {
  return !!user.profile && !!user.team;
}

export function toAvatarStackItem(user: TaskAssigneeUser): AvatarStackItem {
  return {
    id: user.id,
    name: user.full_name,
    src: user.image?.urls.thumbnail,
    colorScheme: user.profile?.hex_color,
    tooltip: hasProfileTooltip(user) ? false : user.full_name,
  };
}
